import { Injectable } from '@angular/core'
import { HttpBackend, HttpClient, HttpErrorResponse } from '@angular/common/http'
import { firstValueFrom } from 'rxjs'
import { environment } from '../../../environments/environment'

const TOKEN_KEY = 'gtm_report_token'
const EXPIRES_KEY = 'gtm_report_expires_at'

// Usuário e senha do relatório ficam no .env do back: o login devolve um token
// assinado, exigido pelo endpoint que traz os dados do GTM
@Injectable({
	providedIn: 'root',
})
export class GtmReportAuthService {
	private http: HttpClient

	constructor(handler: HttpBackend) {
		// Cliente sem interceptors: o AuthInterceptorService trocaria o
		// Authorization pelo token de login do site
		this.http = new HttpClient(handler)
	}

	async login(user: string, password: string): Promise<void> {
		try {
			const response = await firstValueFrom(
				this.http.post<{ token: string; expires_in: number }>(`${environment.gtmReport.api}/gtm-report/login/`, {
					user,
					password,
				})
			)
			sessionStorage.setItem(TOKEN_KEY, response.token)
			sessionStorage.setItem(EXPIRES_KEY, String(Date.now() + response.expires_in * 1000))
		} catch (error) {
			const message = error instanceof HttpErrorResponse ? error.error?.message : ''
			throw new Error(message || 'Não foi possível validar o acesso. Tente novamente.')
		}
	}

	logout(): void {
		sessionStorage.removeItem(TOKEN_KEY)
		sessionStorage.removeItem(EXPIRES_KEY)
	}

	getToken(): string {
		return this.isLoggedIn() ? sessionStorage.getItem(TOKEN_KEY) || '' : ''
	}

	isLoggedIn(): boolean {
		const expiresAt = Number(sessionStorage.getItem(EXPIRES_KEY) || 0)
		return !!sessionStorage.getItem(TOKEN_KEY) && Date.now() < expiresAt
	}
}
